import ServiceJobComponentGroupModel from "./ServiceJobComponentGroupModel";
import ServiceJobOperationModel from "./ServiceJobOperationModel";

export default class ServiceJobComponentModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970,0,1);
			this.name = data.name ?? '';
			this.description = data.description ?? null;

			if (data.componentGroup) {
				this.componentGroup = new ServiceJobComponentGroupModel(data.componentGroup);
			}
			
			if (data.defaultOperation?.operation?.id) {
				this.defaultOperation = new ServiceJobOperationModel(data.defaultOperation.operation);
			}

			if (data.defaultOperation?.id &&
				!this.defaultOperation?.id) {
				this.defaultOperation = new ServiceJobOperationModel(data.defaultOperation);
			}
		}
	}

	id = 0;	
	date = new Date(1970,0,1);
	name = '';
	description: string | null = null;
	componentGroup: ServiceJobComponentGroupModel | null = null;
	defaultOperation: ServiceJobOperationModel | null = null;
}